// eslint-disable-next-line import/prefer-default-export
export const getTagUrl = (tag) => tag.toLowerCase();
